<template>
  	<div id="against">
  		<mt-header fixed :title="$t('闪兑')">
          	<mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
        </mt-header>
        <div class="content">
        	<div class="againstMain">
        		<p class="wx_fontSize2">
        			{{$t('您支付')}}
        			<span>{{$t('可换余额')}}{{price}}{{Fcoin_symbol_display}}</span>
        		</p>
        		<div class="top_main wx_fontSize2">
        			<input type="text" :placeholder="$t('请输入金额')" v-model="FromMount">
        			<span @click="fromList('from')">
        				<img v-bind:src="img_url" alt="" class="mark">
        				<span class="value wx_fontSize3">{{Fcoin_symbol_display}}</span>
        				<img src="../../assets/img/coinDetail/ico_gengduo.png" alt="" class="mark back">
        			</span>
        		</div>
                <div  v-show="isShow">
                    <p class="wx_fontSize2">{{$t('请在以下时间内完成支付以锁定此汇率')}}</p>
                    <p class="wx_fontSize2" style="margin-top: 16px;">
                        1{{Fcoin_symbol_display}} = {{rate | numFilter}}{{Tcoin_symbol_display}}
                        <span style="color:#1296db;left:40%;font-weight: bold;" class="wx_fontSize2" v-if="count>=10">00:00:{{count}}</span>
                        <span style="color:#1296db;left:40%;font-weight: bold;" class="wx_fontSize2" v-else>00:00:0{{count}}</span>
                    </p>
                </div>

        	</div>
        	<img src="../../assets/img/coinDetail/img_duihuan_duihuan.png" alt="" class="zhuanhuan" @click="exchange()">
        	<div class="againstMain">
        		<p class="wx_fontSize2" style="margin-top:0">
        			{{$t('您获得')}}
        		</p>
        		<div class="top_main wx_fontSize2">
        			<input type="text" :placeholder="$t('请输入金额')" :value="toMount" readonly="readonly">
        			<span @click="fromList('to')">
        				<img v-bind:src="Timg_url" alt="" class="mark">
        				<span class="value wx_fontSize3">{{Tcoin_symbol_display}}</span>
        				<img src="../../assets/img/coinDetail/ico_gengduo.png" alt="" class="mark back">
        			</span>
        		</div>
        	</div>
        	<p class="detail wx_fontSize1">{{$t('您获得的币种为空时,说明没有币种可以闪兑。')}}</p>
        	<div class="footer wx_fontSize3" @click="exchangeOrder()">{{$t('立即兑换')}}</div>
        </div>

  	</div>
</template>

<script>
import { Toast } from "mint-ui";
import { numFilter } from "@/filters/index";
import { httpFromCoins , httpToCoins , httpExchangeCheck,httpExchangeOrder,httpExchangePay} from "@/api/index";
import { validateEmpty } from "@/utils/validate";
export default {
    data(){
        return{
            Fcoin_symbol:'',
            Tcoin_symbol:'',
            Fcoin_symbol_display:'',
            Tcoin_symbol_display:'',
            price:'',
            id:'',
            img_url:'',
            Timg_url:'',
            FromMount:'',
            rate:'',
            isShow:false,
            toMount:'',
            count: '',
            timer: null,
            median:'',
            currentUrl:'',
            Tpirce:'',
            currentPrice:''
        }
    },
    activated(){
        this.toMount = '';
        this.FromMount = '';
        if(this.$route.query.coin_symbol && !this.$route.query.result){
            this.Fcoin_symbol = this.$route.query.coin_symbol;
            this.Fcoin_symbol_display = this.$route.query.display_coin_symbol;
            this.price = this.$route.query.price;
            this.img_url = this.$route.query.img_url;
            this.toList();
        }else if(!this.$route.query.coin_symbol && !this.$route.query.result){
            this.formList();
        }else{
            if(this.$route.query.result.access == 'from'){
                this.id = this.$route.query.result.id;
                this.Fcoin_symbol = this.$route.query.result.name;
                this.Fcoin_symbol_display = this.$route.query.result.display_name;
                this.img_url = this.$route.query.result.img_url;
                this.price = this.$route.query.result.cloud_balance;
            }else{
                this.id = this.$route.query.result.id;
                this.Tcoin_symbol = this.$route.query.result.name;
                this.Tcoin_symbol_display = this.$route.query.result.display_name;
                this.Timg_url = this.$route.query.result.img_url;
                this.Tpirce = this.$route.query.result.cloud_balance
            }
        }

    },
    watch:{
        FromMount(val){
            if(val == ''){
                this.isShow = false;
                clearInterval(this.timer);
                this.toMount = '';
                return;
            }else{
                clearInterval(this.timer);
                this.timer = null;
                this.getCode();
            }
        },
        count(val){
            if(val == 0){
                clearInterval(this.timer);
                this.timer = null;
                this.getCode();
            }
        }
    },
    deactivated () {
        clearInterval(this.timer);
    },
    methods:{
        fromList(access){
            this.$router.push({path:"/coinAgaList",query:{access:access,coin_symbol:this.Fcoin_symbol}})
        },
        formList(){
            httpFromCoins({})
            .then(res => {
                this.Fcoin_symbol = res.data.list[0].coin_symbol;
                this.Fcoin_symbol_display = res.data.list[0].display_coin_symbol;
                this.price = res.data.list[0].cloud_balance;
                this.img_url = res.data.list[0].img_url;
                this.toList();
            })
            .catch(() => {});
        },
        toList(){
            httpToCoins({'from_coin':this.Fcoin_symbol})
            .then(res => {
                if(res.code ==1){
                    this.Tcoin_symbol = res.data.list[0].coin_symbol;
                    this.Tcoin_symbol_display = res.data.list[0].display_coin_symbol;
                    this.Timg_url = res.data.list[0].img_url;
                    this.Tpirce = res.data.list[0].cloud_balance;
                }else{
                    Toast(this.$t('暂无数据'))
                }
            })
            .catch(() => {});
        },
        exchangeCheck(type){
            if (validateEmpty(this.Fcoin_symbol) || validateEmpty(this.Tcoin_symbol)) {
                Toast(this.$t("empty"));
                return;
            }
            if(type == 1){
                var p ={'from_coin':this.Tcoin_symbol,'to_coin':this.Fcoin_symbol}
            }else if(type == 0){
                var p ={'from_coin':this.Fcoin_symbol,'to_coin':this.Tcoin_symbol}
            }
            httpExchangeCheck(p)
            .then(res => {
                if(res.code ==1){
                    if(type == 0){
                        this.isShow = true;
                    }else if(type == 1){
                        this.median = this.Tcoin_symbol;
                        this.median_display = this.Tcoin_symbol_display;
                        this.Tcoin_symbol = this.Fcoin_symbol;
                        this.Tcoin_symbol_display = this.Fcoin_symbol_display;
                        this.Fcoin_symbol = this.median;
                        this.Fcoin_symbol_display = this.median_display;
                        this.currentUrl = this.Timg_url;
                        this.Timg_url = this.img_url;
                        this.img_url = this.currentUrl;
                        this.currentPrice = this.Tpirce;
                        this.Tpirce = this.price;
                        this.price = this.currentPrice;
                    }
                    this.rate = res.data.rate;
                    var formStr = numFilter(this.FromMount);
                    var rate = numFilter(this.rate);
                    this.toMount = formStr*rate;
                }else{
                    Toast(res.msg);
                }

            })
            .catch(() => {});
        },
        exchangeOrder(){
            if (validateEmpty(this.Fcoin_symbol) || validateEmpty(this.Tcoin_symbol)|| this.FromMount == '') {
                Toast(this.$t("empty"));
                return;
            }
            var p={
                'from_coin':this.Fcoin_symbol,
                'to_coin':this.Tcoin_symbol,
                'amount':this.FromMount
            }
            httpExchangeOrder(p)
            .then(res => {
                if(res.code ==1){
                    this.exchangePay(res.data.order_id)
                }else{
                    Toast(res.msg);
                }

            })
            .catch(() => {});

        },
        exchangePay(order_id){
            var p={
                'order_id':order_id
            }
            httpExchangePay(p)
            .then(res => {
                Toast(res.msg);
                if(res.code == 1){
                    this.$router.back();
                }
            })
            .catch(() => {});
        },
        getCode(){
            this.exchangeCheck(0);
            const TIME_COUNT = 30;
            if (!this.timer) {
               this.count = TIME_COUNT;
               this.timer = setInterval(() => {
                   if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count=this.count-1;
                    } else {
                        clearInterval(this.timer);
                        this.timer = null;
                    }
               }, 1000)
            }else{

            }
        },
        exchange(){
            this.exchangeCheck(1);
        }

    },
}
</script>

<style scoped>
#against{width:100%;}
.mint-header{background: #ffffff;color:#212529;}
.mint-button--default{color:#656b79 !important;}
.content{background:#f6f6f6;padding-top: 40px;height:100%;}
.againstMain{padding:0 15px;}
.againstMain p{color:#212529;width:100%;font-weight: bold;margin-top: 36px;position: relative;}
.againstMain p span{color:#8c92a8;position: absolute;right: 0;font-weight: normal;text-align: center;}
.top_main{width:100%;background:#fff;height:68px;border-radius: 5px;margin-top: 10px;}
.top_main input{width:60%;height: 68px;line-height: 68px;text-indent: 1em;border-right: 2px solid #f6f6f6;color:#212529;}
.top_main span{display: inline-block;width:calc(40% - 2px);line-height: 68px;}
.top_main span .mark{width:30px;height:30px;position: relative;top:10px;left:16px;}
.top_main span .value{color:#212529;position: relative;left:30px;}
.top_main span .back{width:7px;height:12px;top:0;margin-left: 14px;}
.zhuanhuan{width:19px;height: 19px;margin:18px calc(50% - 9.5px);}
.detail{padding:44px 0 20px 0;width:calc(100% - 30px);margin-left: 15px;color:#8c92a8;}
.footer{width:calc(100% - 30px);height:50px;background:#1296db;line-height:50px;text-align: center;color:#ffffff;border-radius: 4px;margin-left: 15px;}
</style>